module.exports = __webpack_public_path__ + "assets/a74b7c0854f74ab932973778b6429f37.wav";